
import React from 'react';
import { CustomSelectContext } from './CustomSelectContext';

interface CustomSelectValueProps {
  placeholder?: string;
}

export const CustomSelectValue: React.FC<CustomSelectValueProps> = ({
  placeholder
}) => {
  const { value } = React.useContext(CustomSelectContext);
  return <span>{value || placeholder}</span>;
};
